import { Routes } from '@angular/router';
import { ControlusuariosComponent } from './accesos/controlusuarios/controlusuarios.component';
import { RegistrosdeaccesoComponent } from './accesos/registrosdeacceso/registrosdeacceso.component';
import { CambiapasswordComponent } from './auth/cambiapassword/cambiapassword.component';
import { ForgotpasswordComponent } from './auth/forgotpassword/forgotpassword.component';
import { LoginComponent } from './auth/login/login.component';
import { RestablecepasswordComponent } from './auth/restablecepassword/restablecepassword.component';
import { ClientesComponent } from './maestros/clientes/clientes.component';
import { GuardiasComponent } from './maestros/guardias/guardias.component';
import { HomeComponent } from './home/home.component';
import { InstalacionesComponent } from './maestros//instalaciones/instalaciones.component';

import { AdminLayoutComponent } from './layouts/admin/admin-layout.component';
import { AuthLayoutComponent } from './layouts/auth/auth-layout.component';
import { SupervisoresComponent } from './maestros/supervisores/supervisores.component';
import { SoporteComponent } from './maestros/soporte/soporte.component';

import { AuthGuard } from './services/auth.guard';
import { EventosComponent } from './eventos/eventos.component';
import { UsuariosComponent } from './maestros/usuarios/usuarios.component';
import { FacturacionComponent } from './facturacion/facturacion.component';
import { RegistrosaccesosComponent } from './accesos/registrosaccesos/registrosaccesos.component';
import { EmpresasComponent } from './maestros/empresas/empresas.component';
import { PrefacturaComponent } from './prefactura/prefactura.component';
import { AvancesmarketingComponent } from './marketing/avancesmarketing/avancesmarketing.component';
import { VersionesappsComponent } from './maestros/versionesapps/versionesapps.component';
import { McpadopcionComponent } from './maestros/mcpadopcion/mcpadopcion.component';
import { PromocionesComponent } from './maestros/promociones/promociones.component';
import { BotonpanicoComponent } from './maestros/botonpanico/botonpanico.component';

export const AppRoutes: Routes = [
    {
        path: '',
        redirectTo: 'home',
        pathMatch: 'full',
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: HomeComponent, pathMatch: 'full' },
            { path: 'home', component: HomeComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: EventosComponent, pathMatch: 'full' },
            { path: 'eventos', component: EventosComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: BotonpanicoComponent, pathMatch: 'full' },
            { path: 'botonpanico', component: BotonpanicoComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: AvancesmarketingComponent, pathMatch: 'full' },
            { path: 'avancesmarketing', component: AvancesmarketingComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: InstalacionesComponent, pathMatch: 'full' },
            { path: 'instalaciones', component: InstalacionesComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: InstalacionesComponent, pathMatch: 'full' },
            { path: 'instalaciones/:id', component: InstalacionesComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: EmpresasComponent, pathMatch: 'full' },
            { path: 'empresas', component: EmpresasComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: ClientesComponent, pathMatch: 'full' },
            { path: 'clientes', component: ClientesComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: GuardiasComponent, pathMatch: 'full' },
            { path: 'guardias', component: GuardiasComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: ControlusuariosComponent, pathMatch: 'full' },
            { path: 'controlusuarios', component: ControlusuariosComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: RegistrosdeaccesoComponent, pathMatch: 'full' },
            { path: 'registrosdeacceso', component: RegistrosdeaccesoComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: RegistrosaccesosComponent, pathMatch: 'full' },
            { path: 'registrosaccesos', component: RegistrosaccesosComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: SupervisoresComponent, pathMatch: 'full' },
            { path: 'supervisores', component: SupervisoresComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: SoporteComponent, pathMatch: 'full' },
            { path: 'soporte', component: SoporteComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: UsuariosComponent, pathMatch: 'full' },
            { path: 'usuarios', component: UsuariosComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: FacturacionComponent, pathMatch: 'full' },
            { path: 'facturacion', component: FacturacionComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: PrefacturaComponent, pathMatch: 'full' },
            { path: 'prefactura', component: PrefacturaComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: VersionesappsComponent, pathMatch: 'full' },
            { path: 'versionesapps', component: VersionesappsComponent },
            { path: 'mcpadopcion', component: McpadopcionComponent },
            { path: 'promociones', component: PromocionesComponent },
            // La pantalla de keys se fusionó con la de adopción: eran dos entradas
            // del menú con los mismos datos vistos de dos formas. El redirect queda
            // para los enlaces y marcadores que ya apuntaban acá.
            { path: 'mcpkeys', redirectTo: 'mcpadopcion' },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AdminLayoutComponent,
        children: [
            { path: '', component: CambiapasswordComponent, pathMatch: 'full' },
            { path: 'cambiapassword', component: CambiapasswordComponent },
        ],
        canActivate: [AuthGuard]
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [
            { path: '', component: LoginComponent, pathMatch: 'full' },
            { path: 'login', component: LoginComponent },
        ],
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [
            { path: '', component: LoginComponent, pathMatch: 'full' },
            { path: 'login/:prohibido', component: LoginComponent },
        ],
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [
            { path: '', component: ForgotpasswordComponent, pathMatch: 'full' },
            { path: 'forgotpassword', component: ForgotpasswordComponent },
        ],
    },
    {
        path: '',
        component: AuthLayoutComponent,
        children: [
            { path: '', component: RestablecepasswordComponent, pathMatch: 'full' },
            { path: 'restablecepassword/:token', component: RestablecepasswordComponent },
        ],
    },

];
